import axios from 'axios';

const HOSTAPI = process.env.REACT_APP_BASE_URL || '';

interface HeartbeatPayload {
  webinarId: number;
}

const disconnectAttendees = async (payload: HeartbeatPayload): Promise<{ status: number; data: any }> => {
  try {
    const response = await axios.post(`${HOSTAPI}/connection/disconnectAll`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error: any) {
    return {
      status: error.response?.status || 500,
      data: error.response?.data || error.message || 'Unknown error',
    };
  }
};

export default disconnectAttendees;
